import React, { useCallback, useState } from 'react'
import injectStyles from 'react-jss'
import cn from 'classnames'
import { styles } from './styles'

const StyledTooltip = ({
  title,
  children,
  classes,
  className,
  styles = {},
}) => {
  const [show, setShow] = useState(false)

  const handleMouseOver = useCallback(() => {
    setShow(true)
  }, [])

  const handleMouseOut = useCallback(() => {
    setShow(false)
  }, [])

  return (
    <div
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      className={cn(classes.wrapper, className)}
    >
      {show ? (
        <div className={classes.hint} style={styles}>
          {title}
        </div>
      ) : null}
      {children}
    </div>
  )
}

export default injectStyles(styles)(StyledTooltip)
